import colors from "../../Theme/base/colors";
import pxToRem from "../../Theme/functions/pxToRem";
// import typography from "../../Theme/base/typography";

const { text, error } = colors;
// const { size } = typography;

export default {
  styleOverrides: {
    root: {
      fontFamily: "var(--font-inter)",
      top: -6,
      fontSize: pxToRem(14),
      color: text.tertiary,
      // lineHeight: 1.25,

      "&.Mui-focused": {
        color: text.labelBrand,
        // top: 2,
      },

      "&.Mui-error": {
        color: `${error.main}`,
        top: -6,
      },

      "&.Mui-error.Mui-focused": {
        color: `${error.main} !important`,
      },

      "&.MuiInputLabel-shrink": {
        // lineHeight: 2.1,
        // fontSize: '0.75rem !important ',
        paddingLeft: 0,
        paddingRight: 0,
        top: 2,

        "~ .MuiInputBase-root .MuiOutlinedInput-notchedOutline legend": {
          fontSize: "0.78em",
        },
      },
    },

    sizeSmall: {
      //   fontSize: size.xs,
      lineHeight: 1.625,

      "&.MuiInputLabel-shrink": {
        lineHeight: 1.6,
        // fontSize: size.sm,

        "~ .MuiInputBase-root .MuiOutlinedInput-notchedOutline legend": {
          top: 8,
          fontSize: "0.2em",
        },
      },
    },
  },
};
